import { EyeOutlined, MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, Table } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import dayjs from 'dayjs';
import { LodingFilterFormValuesPaginated } from 'features/log/components/Top-bar/type';
import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { getRoute } from 'routes/utils';
import { VehicleLog } from 'types/vehicle';

type VehicleTableProps = {
    isvehicleListLoading: boolean;
    vehicleList: VehicleLog[];
    itemsCount: number;
    tableParams: LodingFilterFormValuesPaginated;
    updateParams: Dispatch<SetStateAction<LodingFilterFormValuesPaginated>>;
    setUserEditData: any;
    setShowAppUserModal: any;
    onApproveReject: any;
};


export const VehicleLoadingLogTable = ({
    vehicleList,
    isvehicleListLoading,
    itemsCount,
    tableParams,
    updateParams,
    onApproveReject
}: VehicleTableProps) => {
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<VehicleLog> | SorterResult<VehicleLog>[]
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };
    const navigate = useNavigate()

    const handleNigate = (item: any) => {
        navigate(getRoute(ROUTES.LOG_ADMIN_DETAIL, item.entryId));
    }

    const handleMenuClick = (record: VehicleLog, e: any) => {
        if (e.key === "approve") {
            onApproveReject(record, 1);
            // your API call for approve
        } else if (e.key === "reject") {
            onApproveReject(record, 2);
            // your API call for reject
        }
    };

    const actionMenu = (record: VehicleLog) => (
        <Menu onClick={(e) => handleMenuClick(record, e)}>
            {(record.isApprovedForExit == 0) ? (
                <>
                    <Menu.Item key="approve">✅ Approve</Menu.Item>
                    <Menu.Item key="reject">❌ Reject</Menu.Item>
                </>
            ) : (record.isApprovedForExit == 1) ? (
                <Menu.Item key="reject">❌ Reject</Menu.Item>
            ) : (
                <Menu.Item key="approve">✅ Approve</Menu.Item>
            )
            }

        </Menu>
    );

    return (
        <>
            <StyledTableWrapper>
                <StyledTableHeader>
                    {/* <RecordCountBadge text={'Vehicle'} count={itemsCount} /> */}
                </StyledTableHeader>

                <Table<VehicleLog>
                    loading={isvehicleListLoading}
                    dataSource={vehicleList}
                    rowKey="id"
                    onChange={handleTableChange}
                    pagination={{
                        current: tableParams.page,
                        defaultPageSize: tableParams.size,
                        total: itemsCount,
                    }}
                >
                    <Column<VehicleLog> title={'Driver Name'} dataIndex={'driverName'} />
                    <Column<VehicleLog> title={'Supplier Name'} dataIndex={'supplierName'} />
                    <Column<VehicleLog> title={'Entry Type'} dataIndex={'entryType'} />
                    <Column<VehicleLog> title={'Vehicle Number'} dataIndex={'vNumber'} />
                    <Column<VehicleLog> title={'Status'} dataIndex={'status'} />
                    <Column<VehicleLog>
                        title={'Vehicle In Time'}
                        dataIndex="vInTime"
                        render={(_, record: any) => (
                            <span>{record.vInTime ? dayjs(record.vInTime).format("MMMM Do YYYY [at] h:mm a") : '-'}</span>
                        )}
                    />
                    <Column<VehicleLog>
                        title="Action"
                        key="action"
                        render={(_, record) => (
                            <>
                                <Dropdown overlay={actionMenu(record)} trigger={["click"]} placement="bottomRight">
                                    <Button type="text" icon={<MoreOutlined style={{ fontSize: 18 }} />} />
                                </Dropdown>

                                <span style={{ cursor: 'pointer' }} role='button' onClick={() => handleNigate(record)}>
                                    <EyeOutlined  />
                                </span>
                            </>
                        )}
                    />

                </Table>
            </StyledTableWrapper>
        </>
    );
};
